import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import {
  IotLightningIcon,
  IotLockdownIcon,
  IotLockIcon,
  IotUnlockIcon,
} from 'src/components/iot/icons';

export const DoorsMenu = ({ doorsRelatedToCamera }: { doorsRelatedToCamera: any[] }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={(e) => {
          handleClick(e);
        }}
        sx={{
          width: '40px',
          height: '40px',
          borderRadius: '8px',
          background: 'rgba(255, 255, 255, 0.10)',
          backdropFilter: 'blur(20px)',
          cursor: 'pointer',
        }}
      >
        <IotLightningIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        PaperProps={{
          style: {
            boxShadow: 'none',
            color: '#fff',
            background: 'rgba(0, 0, 0, 0.60)',
          },
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        {doorsRelatedToCamera && doorsRelatedToCamera?.length > 0 ? (
          doorsRelatedToCamera?.map((device) => {
            return (
              <MenuItem key={device.id} onClick={handleCloseMenu} sx={{ gap: 1 }}>
                {device?.lockedDown ? (
                  <IotLockdownIcon />
                ) : device?.unlocked ? (
                  <IotUnlockIcon />
                ) : (
                  <IotLockIcon />
                )}
                {device.name}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem onClick={handleCloseMenu}>No items</MenuItem>
        )}
      </Menu>
    </>
  );
};
